<template>
    <div>
        <div class="org-tree-layout">
            <swb-popover-org-tree :optionalState="[0,1,3]" :defalultState="[0,1,3]" :showMgmt="true" :bizDepart="true" :tmpBizDepart="false" :selectComId="selectComId" :showIncludeSubComs="true" :initIncludeSubComs="initIncludeSubComs"
                                  @notity-change="checkComCatChange($event)"></swb-popover-org-tree>
        </div>
        <div name="query-sort-block">
            <swb-query-sort-area ref="query_model_ctrl" :confKey="confKey" :configAuto="true" :queryOnLoad="queryOnLoad" :onConfigReady="onQueryConfigReady" :queryHandler="queryHandler" :popupHandler="popupHandler"></swb-query-sort-area>
        </div>
        <div name="btn-bar" class="simple-row">
            <div class="left">
                <!--<div class="swb-btn swb-btn-small" @click="exportAllAsExcel">导出数据</div>-->
                <div class="swb-btn swb-btn-small" @click="toExportDevice">导出贴码</div>
            </div>
            <div class="right">
                <a class="swb-btn swb-btn-small swb-btn-primary" @click="generalImport">导入</a>
                <div class="swb-btn swb-btn-small swb-btn-primary" @click="taskExport()">执行导出任务</div>
                <div class="swb-btn swb-btn-small swb-btn-primary" @click="viewTaskExport()">查看结果文件</div>
                <el-dropdown @command="dropdownEvent">
                    <span class="swb-btn swb-btn-small swb-btn-primary">
                       <span>更多操作</span>
                        <i class="el-icon-arrow-down el-icon--right"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item v-if="!filter.includeSubComs" command="setPrincipaldo">设置责任部门</el-dropdown-item>
                        <el-dropdown-item command="updateShopDeviceTitle">修改资产名称</el-dropdown-item>
                        <el-dropdown-item id="setTag" command="setBizTag">设置业务标签</el-dropdown-item>
                        <el-dropdown-item command="setTemper">设置温控</el-dropdown-item>
                        <el-dropdown-item v-if="checkActionPerm('set_layoutArea')" command="setLayoutArea">设置布放区域</el-dropdown-item>
                        <el-dropdown-item v-if="checkActionPerm('set_classifyTag')" command="setClassifyTag">设置归类标签</el-dropdown-item>
                        <el-dropdown-item v-if="checkActionPerm('del_classifyTag')" command="delClassifyTag">移除归类标签</el-dropdown-item>
                        <el-dropdown-item v-if="checkActionPerm('shopDeviceStart') && allowedToStart" command="shopDeviceStart">批量启用</el-dropdown-item>
                        <el-dropdown-item v-if="checkActionPerm('set_assetIdleX')" command="set_assetIdleX_y">资产闲置</el-dropdown-item>
                        <el-dropdown-item v-if="checkActionPerm('set_assetIdleX')" command="set_assetIdleX_n">取消闲置</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
                <el-dropdown @command="dropdownEvent">
                    <span class="swb-btn swb-btn-small swb-btn-primary">
                       <span>EPSON标签打印</span>
                        <i class="el-icon-arrow-down el-icon--right"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="downloadPrintModel">下载模版</el-dropdown-item>
                        <el-dropdown-item command="exportPrintData1">导出数据</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>

            </div>
        </div>
        <swb-result-table name="result_table" :btnColBaseCount="2" :btnColMoreTitle="'更多操作'" ref="result_table" :confKey="confKey" :configAuto="true" :needPager="needPager" :multiSelect="multiSelect" :multiPageSelect="multiPageSelect"
                          :rowKeyPropName="rowKeyPropName" :rowNoShow="rowNoShow" :rowNoFixed="rowNoFixed" :btnColName="btnColName" :btnColTitle="btnColTitle" :btnColWidth="btnColWidth" :btnColFixed="btnColFixed" :height="tableHeight"
                          :pageNoChangeHandler="pageNoChangeHandler" :rowDblClickHandler="rowDblClickHandler"></swb-result-table>
        <swb-dt-popover ref="popoverRef" classes="popper-tabs">
            <swb-biz-tag-list-for-select :bizAspect="1" :selectIds="selectTagIds" ref="swb_biz_tag_list_for_select" @notity-bizTag-comfirm="doConfirm" @notity-bizTag-cancel="doCancel"></swb-biz-tag-list-for-select>
        </swb-dt-popover>
    </div>
</template>

<script>
    import {Utils, $} from '../../app.base'
    import {Vue, MsgBox, Routes, DomSizeWatcher, getComnMerchantBizTag} from '../../app.vues'
    import {checkUserActionPerm, getMerchtAssetNatureMap} from '../index'
    import {getDefaultPageSizes, getDefaultDownloadPageSize} from '../../app.conf'
    import {shopDeviceEditInfoDlg, assetCaseRecordDlg} from '../retailer/dialog'
    import {openBizDepartDlg, openComStaffMainForSelectDlg} from '../orgStruct/selectDlg'
    import {
        openShopDeviceSuitSelectDlg,
        showSetTemperInfoDlg,
        openShopDeviceFiscalInImpCheckDlg
    } from '../retailer/selectDlg'
    import {openBigImgDlg, fileUploadGroupShowDlg} from '../comn/dialog'
    import {showGrpDownloadDlg, showDownloadDlg} from '../ctrl/dialog'
    import {
        loadShopWarehouseList,
        loadRetailerDevcGroupCascList,
        loadDevcCatListList, getAssetKindListAll
    } from '../retailer/asset-comn'
    import {showAsmblAccStockSetSelectDlg} from '../asmblAcc/dialog';
    import {openLayoutAreaTreeSelectDlg} from '../layoutArea/showDlg';
    import {showDevcCustInfoSaveDlg} from '../devcCust/selectDlg';
    import {openServicerListForDeviceDlg} from '../spec/selectDlg';
    import {getIncludeSubComsByMetaQueryConf} from '../conf/ComnConfStorer';
    import {createTaskExportDlg, viewTaskExportListDlg, showShopDeviceInfo, showDevcRelatedPartListDlg} from './selectDlg';
    import {getMerchantBizParam} from '../asset/assetMain';
    //
    import devcApi from '../../api/devc';
    import assetVchrApi from '../../api/assetVchr'
    import userApi from '../../api/user'
    import merchtComnApi from '../../api/merchtComn'
    import comnApi from '../../api/comn'

    import SwbShopDeviceSuitList from '../retailer/ShopDeviceSuitList'

    Routes.add(SwbShopDeviceSuitList);

    import SwbAssetRunRepaire from '../retailer/AssetRunRepaire'

    Routes.add(SwbAssetRunRepaire);

    import SwbResultColConf from '../query/ResultColConf.vue';
    import SwbResultTable from '../query/ResultTable.vue';

    Vue.regist(SwbResultColConf);
    Vue.regist(SwbResultTable);

    import SwbQuerySortArea from '../query/QuerySortArea';

    Vue.regist(SwbQuerySortArea);
    import SwbBizTagListForSelect from '../bizTag/BizTagListForSelect'

    Vue.regist(SwbBizTagListForSelect);

    import SwbShopDeviceTransVoucherApplyList from '../transVoucher/ShopDeviceTransVoucherApplyList';
    import SwbShopDeviceTransVoucherAuditList from '../transVoucher/ShopDeviceTransVoucherAuditList';
    import SwbShopDeviceTransVoucherDevcApplyList from '../tranVoucherDevc/ShopDeviceTransVoucherApplyList';
    import SwbShopDeviceTransVoucherDevcAuditList from '../tranVoucherDevc/ShopDeviceTransVoucherAuditList';
    import SwbShopDeviceScrapVoucherApplyList from '../scrapVoucher/ShopDeviceScrapVoucherApplyList';
    import SwbShopDeviceScrapVoucherAuditList from '../scrapVoucher/ShopDeviceScrapVoucherAuditList';
    import SwbShopDeviceClearVoucherApplyList from '../clearVoucher/ShopDeviceClearVoucherApplyList';
    import SwbShopDeviceClearVoucherAuditList from '../clearVoucher/ShopDeviceClearVoucherAuditList';
    import SwbAssetDeprAdjustVoucherList from '../assetFiscal/AssetDeprAdjustVoucherList';
    import SwbAssetDeprAdjustVoucherAuditList from '../assetFiscal/AssetDeprAdjustVoucherAuditList';
    import SwbDevcSplitFormList from '../devcSplit/DevcSplitFormList';
    import SwbDevcMergeFormList from '../devcMerge/DevcMergeFormList';
    import SwbPurchReceiptManualList from '../receipt/PurchReceiptManualList';
    import SwbShopDeviceAppturnVoucherList from '../retailer/ShopDeviceAppturnVoucherList';
    import SwbShopDeviceAppReturnVoucherList from '../retailer/ShopDeviceAppReturnVoucherList';

    Routes.add(SwbShopDeviceTransVoucherApplyList);
    Routes.add(SwbShopDeviceTransVoucherAuditList);
    Routes.add(SwbShopDeviceTransVoucherDevcApplyList);
    Routes.add(SwbShopDeviceTransVoucherDevcAuditList);
    Routes.add(SwbShopDeviceScrapVoucherApplyList);
    Routes.add(SwbShopDeviceScrapVoucherAuditList);
    Routes.add(SwbShopDeviceClearVoucherApplyList);
    Routes.add(SwbShopDeviceClearVoucherAuditList);
    Routes.add(SwbAssetDeprAdjustVoucherList);
    Routes.add(SwbAssetDeprAdjustVoucherAuditList);
    Routes.add(SwbDevcSplitFormList);
    Routes.add(SwbDevcMergeFormList);
    Routes.add(SwbPurchReceiptManualList);
    Routes.add(SwbShopDeviceAppturnVoucherList);
    Routes.add(SwbShopDeviceAppReturnVoucherList);

    let bizTagObj = null;
    //invalidate
    export default {
        name: 'swb-shop-device-list',
        desc: '资产列表',
        path: '/shop/device/list',
        data: function () {
            return {
                confKey: 'swb-shop-device-list',
                queryOnLoad: true,
                tableHeight: 500,
                //
                needPager: true, //是否需要分页（默认：true）
                multiSelect: true, //是否多选（默认：false）
                multiPageSelect: true, //是否要多页/跨页选择（默认：false）
                rowKeyPropName: 'id', //记录数据关键标识列名（多页/跨页选择必须，默认: id）
                rowNoShow: false, //是否显示行号（默认：true）
                rowNoFixed: false, //行号列是否固定（默认：false）

                btnColName: 'actions',//操作列名称（如果不设置就不显示操作列）
                //
                btnColTitle: '操作',//操作列标题（默认：'操作'）
                btnColWidth: 200,//操作列宽度（默认：100）
                //
                btnColFixed: true, //操作列是否固定
                resultColConf: {//不想要列配置设置 = null即可
                    metaColList: []
                },
                //
                pageSize: getDefaultPageSizes().first(),
                pageNumber: 1,
                //
                startValue: getEnumInfoWith('deviceUseState', 'name', 'Start').value,
                inactiveValue: getEnumInfoWith('deviceUseState', 'name', 'Inactive').value,
                outageValue: getEnumInfoWith('deviceUseState', 'name', 'Outage').value,
                assetNatureMap: getEnumMap('assetNature', 'value2text'),
                assetTypeMap: getEnumMap('assetType', 'value2text'),
                leaseStateMap: getEnumMap('leaseState', 'value2text'),
                acctEnterWayMap: getEnumMap('acctEnterWay', 'value2text'),
                devcVoucherTypeMap: getEnumMap('devcVoucherType', 'value2text'),
                //排序、搜索
                queryConfig: {},
                queryKey: null,
                queryModel: {
                    filterItems: {},
                    sortItemList: [],
                    sortItems: {},
                },
                exportParmas: null,
                //
                initIncludeSubComs: false,
                scopeEntity: {},
                lastPageNumber: null,
                bizTag: false,// 为了区分是设置标签还是标签管理
                selectTagId: null,
                selectTagIds: [], // 回显标签数据用
                scopeId: null,
                curBtn: null,
                devcCustFieldList: [],
                //
                filter: {},
                selectComId: null,
                retailerBizUnitId: null,
                allowedToStart: false,
            }
        },
        created: function () {
            let self = this;
            bizTagObj = getComnMerchantBizTag();
            this.filter = this.$route.query.filter || {};
            //
            getIncludeSubComsByMetaQueryConf('swb-shop-device-list', function (includeSubComs) {
                self.filter.includeSubComs = includeSubComs;
                self.initIncludeSubComs = includeSubComs;
            });
            // 无领用人/使用人的设备是否允许启用
            getMerchantBizParam('un.applied.device.allowed.to.start', function (result) {
                self.allowedToStart = Utils.isTrue(result);
            }, 0);
            //
            let tmpNo = this.$route.query.tmpNo || null;
            if (!Utils.isNoB(tmpNo)) {
                this.initIncludeSubComs = true;
                this.filter.tmpNo = tmpNo || null;
                this.filter.includeSubComs = true;
            }
            if (!Utils.isNoB(this.$route.query.includeSubComs)) {
                this.filter.includeSubComs = this.$route.query.includeSubComs;
                self.initIncludeSubComs = this.$route.query.includeSubComs;
            }
            if (!Utils.isNoB(this.$route.query.importNo)) {
                this.filter.importNo = this.$route.query.importNo;
            }
            if (!Utils.isNoB(this.$route.query.retailerComId)) {
                this.filter.retailerComId = this.$route.query.retailerComId;
            }
            if (!Utils.isNoB(this.filter.retailerComId)) {
                this.selectComId = this.filter.retailerComId;
            }
            //
            this.getCurrentUserInfo();
            this.getDevcCustFieldList();
        },
        mounted() {
            let self = this;
            //注册domSizeWatcher
            let thisEl = $(this.$el);
            $(this.$el).addClass('overflow-hidden');
            //
            let domSizeWatcher = this.domSizeWatcher = new DomSizeWatcher(Vue.$getClassInfo(this).name);
            domSizeWatcher.setBaseEl(thisEl);
            domSizeWatcher.setMainEl(thisEl.find('[name="result_table"]'), function (width, height, theEl) {
                //根据新主元素的内容大小，调整表格高度
                self.tableHeight = height;
            });
            //domSizeWatcher.setHrEls();
            domSizeWatcher.setVtEls(thisEl.find('[name="query-sort-block"], .org-tree-layout, [name="btn-bar"]'));
            domSizeWatcher.start(500);
            //
            this.initResultTable();
        },
        destroyed() {
            //释放domSizeWatcher
            let domSizeWatcher = this.domSizeWatcher;
            if (domSizeWatcher != null) {
                domSizeWatcher.clear();
                this.domSizeWatcher = null;
            }
        },
        methods: {
            checkComCatChange: function (eventData) {
                let filter = this.filter || {};
                filter.retailerComId = eventData.id;
                this.retailerBizUnitId = eventData.bizUnitId;
                filter.includeSubComs = eventData.includeSubComs;
                this.filter = Utils.merge({}, filter);
                //
                this.getShopDeviceList();
            },
            onQueryConfigReady: function () {
                this.initAsyncQueryModel();
            },
            initAsyncQueryModel() {
                let self = this;
                let filter = self.filter || {};
                let comId = filter.retailerComId;
                // 资产分类
                loadDevcCatListList(function (dataList) {
                    self.updateQueryModelField('innerDevcCatId', dataList);
                });
                // 分类分组
                loadRetailerDevcGroupCascList(function (dataList) {
                    self.updateQueryModelField('devcGroupId', dataList);
                });
                // 加载仓库
                loadShopWarehouseList(comId, function (dataList) {
                    self.updateQueryModelField('warehouseId', dataList);
                });
                // 资产属性
                getMerchtAssetNatureMap((merchtAssetNatureList) => {
                    if (merchtAssetNatureList.length > 0) {
                        let dataList = [{'value': null, 'label': '- 全部 -'}];
                        merchtAssetNatureList.forEach(function (item) {
                            let dataInfo = {};
                            dataInfo.value = item.value;
                            dataInfo.label = item.text;
                            dataList.push(dataInfo);
                        });
                        self.updateQueryModelField('assetNature', dataList);
                    }
                });
                getAssetKindListAll(function (dataList) {
                    let showAssetKindList = [];
                    dataList.forEach(function (item) {
                        showAssetKindList.push({
                            value: item.id,
                            label: item.name
                        });
                    });
                    self.updateQueryModelField('assetKindId', showAssetKindList);
                });
                //
                let tmpNo = filter.tmpNo;
                if (!Utils.isNoB(tmpNo)) {
                    self.updateQueryModelValueField('tmpNo', tmpNo);
                }
                //
                let importNo = filter.impNo;
                if (!Utils.isNoB(importNo)) {
                    self.updateQueryModelValueField('importNo', importNo);
                }
                //
                let title = filter.title;
                if (!Utils.isNoB(title)) {
                    self.updateQueryModelValueField('title', title);
                }
                bizTagObj.loadSelectBizTagByBizAspect(1, function (dataList) {
                    self.updateQueryModelField('bizTag', dataList);
                });
            },
            updateQueryModelField: function (itemCode, dataList = []) {
                if (itemCode != null) {
                    let query_model_ctrl = this.$refs['query_model_ctrl'];
                    let data = {dataList: dataList};
                    let fieldInfo = {};
                    fieldInfo[itemCode] = data;
                    query_model_ctrl.updateFields(fieldInfo);
                }
            },
            updateQueryModelValueField: function (itemCode, dataValue) {
                if (itemCode != null) {
                    let query_model_ctrl = this.$refs['query_model_ctrl'];
                    let data = {value: dataValue};
                    let fieldInfo = {};
                    fieldInfo[itemCode] = data;
                    query_model_ctrl.updateFields(fieldInfo);
                }
            },
            updateQueryModelHiddenField: function (itemCode, hiddenValue) {
                if (itemCode != null) {
                    let query_model_ctrl = this.$refs['query_model_ctrl'];
                    let data = {hidden: hiddenValue};
                    let fieldInfo = {};
                    fieldInfo[itemCode] = data;
                    query_model_ctrl.updateFields(fieldInfo);
                }
            },
            initResultTable() {
                let self = this;
                let query_model_ctrl = this.$refs['query_model_ctrl'];
                let resultTable = this.$refs['result_table'];
                //关联[查询排序对象]到结果表格（结果表格可以实时利用最新的 列配置 和 排序信息，同时结果表格列宽也会反向同步到其中的[列配置对象]中去）
                resultTable.setQrySortRef(query_model_ctrl);
                //
                resultTable.initMeta(/* confColList, */ /* 单元格html渲染函数 */{
                    'statusLabel': function (row, colName, colValue, rowIndex, colConf) {
                        let domHtml = '';
                        var outWrnt = false;
                        if (row.wrntDueTime != null && new Date(row.currentTime).getTime() > new Date(row.wrntDueTime).getTime()) {
                            domHtml = domHtml + '<a class="swb-tags swb-tags-outlined">保外</a>';
                            outWrnt = true;
                        }
                        if (!outWrnt) {
                            if (row.wrntDueTime == null || new Date(row.currentTime).getTime() <= new Date(row.wrntDueTime).getTime()) {
                                domHtml = domHtml + '<a class="swb-tags swb-tags-outlined">保内</a>';
                            }
                        }
                        if (row.tagMissing) {
                            domHtml = domHtml + '<a class="swb-tags swb-tags-outlined">缺码</a>';
                        }
                        return domHtml;
                    },
                    'imageUrl': function (row, colName, colValue, rowIndex, colConf) {
                        if (row.imageUrl) {
                            return '<img style="height: 36px;width: 36px" src="' + row.imageUrl + '"/>';
                        } else {
                            return '';
                        }
                    },
                    'assetTypeTitle': function (row, colName, colValue, rowIndex, colConf) {
                        return self.assetTypeMap[row.assetType];
                    },
                    'fiscalAcctName': function (row, colName, colValue, rowIndex, colConf) {
                        return (row.fiscalAcctFlag == 1 ? '是' : '否');
                    },
                    'assetNatureName': function (row, colName, colValue, rowIndex) {
                        return self.assetNatureMap[row.assetNature];
                    },
                    'bizTag': function (row, colName, colValue, rowIndex, colConf) {
                        let html = '';
                        let bizTag = row.bizTag || null;
                        if (!Utils.isNoB(bizTag)) {
                            if (bizTag.indexOf('|') >= 0) {
                                let tagIdList = bizTag.split('|') || [];
                                for (let i = 0, c = tagIdList.length; i < c; i++) {
                                    let tagId = tagIdList[i];
                                    let tagName = bizTagObj.getBizTagNameById(tagId);
                                    if (tagName != null) {
                                        html += '<span class="swb-tags swb-tags-success mr5">' + tagName + '</span>';
                                    }
                                }
                            } else {
                                html = '<span class="swb-tags swb-tags-success mr5">' + bizTag + '</span>';
                            }
                        }
                        return html;
                    },
                    'suitMainFlag': function (row, colName, colValue, rowIndex, colConf) {
                        let domHtml = '';
                        if (row.suitId != null) {
                            if (row.suitMainFlag) {
                                domHtml = '<span class="font-green">是</span>';
                            } else {
                                domHtml = '<span>否</span>';
                            }
                        }
                        return domHtml;
                    },
                    'imported': function (row, colName, colValue, rowIndex, colConf) {
                        if (colValue) {
                            return '<span class="font-green">是</span>';
                        } else {
                            return '<span class="font-red">否</span>';
                        }
                    },
                    'useStateName': function (row, colName, colValue, rowIndex, colConf) {
                        let domHtml = '';
                        if (row.useState == self.inactiveValue) {
                            domHtml = '<span class="font-black">未启用</span>';
                        } else if (row.useState == self.outageValue) {
                            domHtml = '<span class="font-gold">已停用</span>';
                        } else if (row.useState == self.startValue) {
                            domHtml = '<span class="font-green">已启用</span>';
                        }
                        return domHtml;
                    },
                    'scrapped': function (row, colName, colValue, rowIndex, colConf) {
                        if (colValue) {
                            return '<span class="font-green">是</span>';
                        } else {
                            return '<span class="font-red">否</span>';
                        }
                    },
                    'devcDefFlagName': function (row, colName, colValue, rowIndex, colConf) {
                        if (row.devcDefId == -1) {
                            return '<span>未关联</span>';
                        } else {
                            return '<span>已关联</span>';
                        }
                    },
                    'leaseState': function (row, colName, colValue, rowIndex, colConf) {
                        return self.leaseStateMap[colValue];
                    },
                    'acctEnterWayName': function (row, colName, colValue, rowIndex, colConf) {
                        let acctEnterWay = self.acctEnterWayMap[row.acctEnterWay] || '';
                        //
                        return '<span>' + acctEnterWay + '</span>';
                    },
                    'lockBizTypeText': function (row, colName, colValue, rowIndex) {
                        if (Utils.isTrue(row.locked)) {
                            return '<span>' + self.devcVoucherTypeMap[row.lockBizType] + '</span>';
                        } else {
                            return '';
                        }
                    },
                    'lockBizInnerNo': function (row, colName, colValue, rowIndex) {
                        if (Utils.isTrue(row.locked)) {
                            return '<a class="table-cell-link">' + row.lockBizInnerNo + '</a>';
                        } else {
                            return '';
                        }
                    },
                    'stateTag': function (row, colName, colValue, rowIndex, colConf) {  // 状态标签
                        let html = '';
                        if (row.abscent) {
                            return '<span class="swb-tags swb-tags-success mr5">无实物</span>';
                        }
                        // 非业务
                        if (row.repairingFlag == 0 && row.idleFlag == 0 && !row.maintingFlag && !row.scrapped && !row.currExamineFlag) {
                            if (row.useState == 2) { // 已停用
                                html += '<span class="swb-tags swb-tags-success mr5">闲置</span>';
                            } else {
                                html += '<span class="swb-tags swb-tags-success mr5">正常使用</span>';
                            }
                        } else {
                            if (row.repairingFlag == 1) {
                                html += '<span class="swb-tags swb-tags-success mr5">维修</span>';
                            }
                            if (row.idleFlag == 1) {
                                html += '<span class="swb-tags swb-tags-success mr5">闲置</span>';
                            }
                            if (row.maintingFlag) {
                                html += '<span class="swb-tags swb-tags-success mr5">保养</span>';
                            }
                            if (row.scrapped) {
                                html += '<span class="swb-tags swb-tags-success mr5">报废</span>';
                            }
                            if (row.currExamineFlag) {
                                html += '<span class="swb-tags swb-tags-success mr5">检验</span>';
                            }
                        }
                        return html;
                    },
                    'actions': function (row, colName, colValue, rowIndex) {
                        let btnList = [];
                        if (self.checkActionPerm('modify')) {
                            btnList.push({
                                name: 'modify',
                                text: '编辑'
                            });
                        }
                        if (self.checkActionPerm('view_detail')) {
                            btnList.push({
                                name: 'view_detail',
                                text: '详情'
                            });
                        }
                        //  跟随清除功能一起实现
                        let cleared = Utils.isTrue(row.leaseState == 0 && row.retailerBizUnitId == self.scopeEntity.bizUnitId && row.fiscalAcctFlag == 0);
                        if (self.checkActionPerm('quick_act', row.retailerComId) && row.inStkQuantity > 0 && self.scopeId == 4 && row.fiscalAcctFlag == 0) {
                            btnList.push({
                                name: 'quick_act',
                                text: '清除'
                            });
                        }
                        if (self.checkActionPerm('case_record')) {
                            btnList.push({
                                name: 'case_record',
                                text: '档案记录'
                            });
                        }
                        if (self.checkActionPerm('suitInfo') && row.suitId != null && self.scopeId == 4 && row.assetType == 0) {
                            btnList.push({
                                name: 'suitInfo',
                                text: '所属套装'
                            });
                        }
                        if (self.checkActionPerm('device_req_maint') && self.scopeId == 4 && row.assetType == 0) {
                            btnList.push({
                                name: 'device_req_maint',
                                text: '设备维保情况'
                            });
                        }
                        if (self.checkActionPerm('updateBizTag')) {
                            btnList.push({
                                name: 'updateBizTag',
                                text: '设置业务标签'
                            });
                        }
                        if (self.checkActionPerm('useAsmblAcc') && row.asmblFlag && !row.asmblDone && row.assetType == 0) {
                            btnList.push({
                                name: 'useAsmblAcc',
                                text: '组装'
                            });
                        }
                        if (self.checkActionPerm('setAbscent') && !row.abscent && row.repairingFlag == 0 && !row.maintingFlag && row.assetType == 0) {
                            btnList.push({
                                name: 'setAbscent',
                                text: '无实物'
                            });
                        }
                        if (self.checkActionPerm('setAbscent') && row.abscent && row.assetType == 0) {
                            btnList.push({
                                name: 'setAbscent',
                                text: '有实物'
                            });
                        }
                        if (self.checkActionPerm('set_layoutArea') && row.assetType == 0) {
                            btnList.push({
                                name: 'set_layoutArea',
                                text: '设置布放区域'
                            });
                        }
                        if (self.checkActionPerm('cancel_layoutArea') && row.layoutAreaId != null && row.layoutAreaId != -1 && row.assetType == 0) {
                            btnList.push({
                                name: 'cancel_layoutArea',
                                text: '取消布放区域'
                            });
                        }
                        if (self.checkActionPerm('set_classifyTag') && row.assetType == 0) {
                            btnList.push({
                                name: 'set_classifyTag',
                                text: '设置归类标签'
                            });
                        }
                        if (self.checkActionPerm('del_classifyTag') && row.assetType == 0) {
                            btnList.push({
                                name: 'del_classifyTag',
                                text: '移除归类标签'
                            });
                        }
                        if (self.checkActionPerm('devc_part') && row.assetType == 0) {
                            btnList.push({
                                name: 'devc_part',
                                text: '设备部件'
                            });
                        }
                        if (self.checkActionPerm('maint_servicer')) {
                            btnList.push({
                                name: 'maint_servicer',
                                text: '维保服务商'
                            });
                        }
                        if (self.checkActionPerm('shopDeviceStart') && self.allowedToStart && row.useState == 0) { // 仅未启用可手工启用、启用后可领用
                            btnList.push({
                                name: 'shopDeviceStart',
                                text: '启用'
                            });
                        }
                        if (self.checkActionPerm('set_assetIdleX')) {
                            btnList.push({
                                name: 'set_assetIdleX',
                                text: !row.assetIdleX ? '标记资产闲置' : '取消资产闲置'
                            });
                        }
                        return btnList;
                    }
                }, /* 单元格按钮点击处理函数 */{
                    //*代表可处理未指定事件函数的任意列的按钮/链接的点击
                    'imageUrl': function (row, colName, colValue, rowIndex, btnName) {
                        self.viewImage(row.imageUrl);
                    },
                    'lockBizInnerNo': function (row, colName, colValue, rowIndex, btnName) {
                        if (Utils.isTrue(row.locked)) {
                            self.toLockedBizVoucher(row);
                        }
                    },
                    'actions': function (row, colName, colValue, rowIndex, btnName, evnt) {
                        if (btnName == 'modify') {
                            // 编辑信息、信息单
                            self.editInfo(row);
                        } else if (btnName == 'view_detail') {
                            self.showSvcSubNoInfo(row);
                        } else if (btnName == 'quick_act') {
                            // 快捷操作【清理、报废】
                            self.doShopDeviceClear(row);
                        } else if (btnName == 'case_record') {
                            self.AssetCaseRecord(row);
                        } else if (btnName == 'suitInfo') {
                            self.gotoSuit(row.suitId);
                        } else if (btnName == 'device_req_maint') {
                            // 设备维保情况
                            self.deviceReqMaint(row);
                        } else if (btnName == 'updateBizTag') {
                            // 设备维保情况
                            self.updateBizTag(evnt, row);
                        } else if (btnName == 'useAsmblAcc') {
                            self.useAsmblAcc(row);
                        } else if (btnName == 'setAbscent') {
                            self.setAbscent([row.id], row.abscent);
                        } else if (btnName == 'set_layoutArea') {
                            // 设置布放区
                            self.setLayoutArea(row)
                        } else if (btnName == 'cancel_layoutArea') {
                            // 取消布放区
                            self.cancelLayoutArea(row);
                        } else if (btnName == 'set_classifyTag') {
                            self.setClassifyTag(row);
                        } else if (btnName == 'del_classifyTag') {
                            self.delClassifyTag(row);
                        } else if (btnName == 'devc_part') {
                            // 设备部件
                            self.toViewDevcPart(row);
                        } else if (btnName == 'maint_servicer') {
                            // 维保服务商
                            self.toViewMaintServicer(row);
                        } else if (btnName == 'shopDeviceStart') {
                            // 批量启用
                            self.shopDeviceStart(row.id);
                        } else if (btnName == 'set_assetIdleX') {
                            self.updateAssetIdleX(row.id, !row.assetIdleX, row.assetType, row.existQuanity);
                        }
                    }
                });
            },
            renderTable(rows, pagination) {
                let resultTable = this.$refs.result_table;
                let tableData = {
                    rows: rows,
                    pagination: pagination
                };
                resultTable.render(tableData);
            },
            // 单元格点击事件
            rowDblClickHandler: function (row) {
                if (!this.multiSelect) {
                    console.log(row);
                }
            },
            getTableSelection() {
                let resultTable = this.$refs.result_table;
                return resultTable.getSelection();
            },
            getCurrentUserInfo: function () {
                let self = this;
                userApi.getUserInfoByContext({}, function (result, jqXhr) {
                    if (result.type == 'info') {
                        let data = result.data;
                        let scopeEntity = data.scopeEntity;
                        self.scopeEntity = scopeEntity;
                        self.scopeId = scopeEntity.scopeId;
                        if (Utils.isNoB(self.filter.retailerComId)) {
                            self.selectComId = scopeEntity.comId;
                        }
                    } else {
                        self.$message.warning(result.message);
                    }
                });
            },
            checkActionPerm: function (action, dataOwnerComId) {
                return checkUserActionPerm(Vue.$getClassInfo(this).path, action, null, dataOwnerComId);
            },
            queryHandler(queryModel) {
                this.queryModel = queryModel;
                this.pageNumber = 1;
                this.lastPageNumber = null;
                //
                this.getShopDeviceList();
            },
            pageNoChangeHandler: function (pageNumber, pageSize) {
                console.log('分页 => 第【' + pageNumber + '】页，大小：' + pageSize);
                //
                this.pageSize = pageSize;
                this.pageNumber = pageNumber;
                this.lastPageNumber = null;
                //
                this.getShopDeviceList();
            },
            getShopDeviceList: function () {
                let self = this;
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                //
                let queryModel = self.queryModel;
                let filterItems = Utils.merge({}, queryModel.filterItems);
                let sortItemList = Utils.merge([], queryModel.sortItemList);
                let sortItems = Utils.merge({}, queryModel.sortItems);
                //
                let filter = self.filter || {};
                filterItems = Object.assign(filterItems, filter);
                //
                filterItems.devcBizClolumType = getEnumInfoWith('devcBizClolumType', 'name', 'SheBeiMX').name;
                //
                if (!Utils.isNoB(filterItems.assetKindId) && typeof filterItems.assetKindId == 'number') {
                    filterItems.kindLevelFlag = true;
                }
                let suitIds = filterItems.suitIds;
                if (!Utils.isNoB(suitIds)) {
                    filterItems.suitIds = suitIds.split('_');
                }
                //
                postData.filterItems = filterItems;
                postData.sortItemList = sortItemList;
                postData.sortItems = sortItems;
                self.exportParmas = filterItems;
                //
                let theLoad = MsgBox.loading();
                devcApi.getShopDeviceListByFilter(postData, function (result) {
                    theLoad.hide();
                    if (result.type === 'info') {
                        let data = result.data;
                        let list = data.rows || [];
                        //
                        let pagination = result.data.pagination;
                        self.totalCount = pagination.totalCount;
                        self.pageNumber = pagination.pageNumber;
                        self.pagesize = pagination.pageSize;
                        //
                        self.renderTable(list, pagination);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },

            // 下拉操作
            dropdownEvent: function (command) {
                let self = this;
                switch (command) {
                case 'downloadPrintModel' :
                    self.downloadPrintModel();
                    break;
                case 'exportPrintData1' :
                    self.exportPrintData1();
                    break;
                case 'setPrincipaldo' :
                    self.setPrincipaldo();
                    break;
                case 'updateShopDeviceTitle' :
                    self.updateShopDeviceTitle();
                    break;
                case 'setBizTag' :
                    self.setBizTag();
                    break;
                case 'setTemper' :
                    self.setTemper();
                    break;
                case 'setLayoutArea' :
                    self.setLayoutArea();
                    break;
                case 'setClassifyTag' :
                    self.setClassifyTag();
                    break;
                case 'delClassifyTag' :
                    self.delClassifyTag();
                    break;
                case 'shopDeviceStart' :
                    self.shopDeviceStart();
                    break;
                case 'set_assetIdleX_y' :
                    self.updateAssetIdleX(null, true, null, 0);
                    break;
                case 'set_assetIdleX_n' :
                    self.updateAssetIdleX(null, false, null, 0);
                    break;
                }
            },
            // 启用
            shopDeviceStart: function (deviceId) {
                let self = this;
                let ids = [];
                if (Utils.isNoB(deviceId)) {
                    // 批量启用
                    let multipleSelection = this.getTableSelection() || [];
                    let length = multipleSelection.length;
                    if (length <= 0) {
                        MsgBox.warning('请选择需启用的设备');
                        return;
                    }
                    let warnMsg = null;
                    for (let i = 0; i < length; i++) {
                        let shopDevice = multipleSelection[i];
                        if (shopDevice.useState != 0) {   // 未启用设备可以启用。
                            warnMsg = '【' + shopDevice.title + '】设备已启用';
                            break;
                        }
                    }
                    if (!Utils.isNoB((warnMsg))) {
                        MsgBox.warning(warnMsg);
                        return;
                    }
                    ids = multipleSelection.pluck('id');
                } else {
                    ids = [deviceId];
                }
                this.$confirm('确定要启用吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    let theLoad = MsgBox.loading();
                    let postData = {
                        ids: ids
                    };
                    devcApi.updateShopDeviceForStart(postData, function (result) {
                        theLoad.hide();
                        if (result.type === 'info') {
                            MsgBox.success('设置成功！');
                            //
                            let resultTable = self.$refs['result_table'];
                            resultTable.setInitChecked([]);
                            //
                            self.getShopDeviceList();
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                }).catch(function () {
                });
            },
            // 批量设置责任部门责任人
            setPrincipaldo: function () {
                let self = this;
                let multipleSelection = this.getTableSelection();
                let ids = multipleSelection.pluck('id');
                if (ids != null && ids.length > 0) {
                    //
                    let retailerBizUnitIds = multipleSelection.pluck('retailerBizUnitId');
                    let retailerBizUnitId = retailerBizUnitIds[0];
                    // 判斷是否是一個機構
                    for (let i = 0; i < retailerBizUnitIds.length; i++) {
                        let bizUnitId = retailerBizUnitIds[i];
                        if (retailerBizUnitId != bizUnitId) {
                            MsgBox.warning('勾选的资产业务单元不一致，请确认！');
                            return;
                        }
                    }
                    openComStaffMainForSelectDlg({defComId: retailerBizUnitId, bizUnitId: retailerBizUnitId}, function (staff, theDlg) {
                        theDlg.close();
                        let postData = {};
                        postData.ids = ids;
                        postData.departId = staff.srcComId;
                        postData.departName = staff.srcComName;
                        postData.principalId = staff.id;
                        postData.principalName = staff.name;
                        //
                        let theLoad = MsgBox.loading();
                        devcApi.doShopDevicePrincipalSet(postData, function (result) {
                            theLoad.hide();
                            if (result.type === 'info') {
                                MsgBox.success('设置成功！');
                                //
                                let resultTable = self.$refs['result_table'];
                                resultTable.setInitChecked([]);
                                //
                                self.getShopDeviceList();
                            } else {
                                MsgBox.warning(result.message);
                            }
                        });
                    }, '责任人信息 - 选择');
                } else {
                    MsgBox.warning('未选择数据！');
                }
            },
            // 批量修改设备名称
            updateShopDeviceTitle: function () {
                let self = this;
                let multipleSelection = this.getTableSelection();
                let ids = multipleSelection.pluck('id');
                if (ids != null && ids.length > 0) {
                    let durable = false;
                    for (let i = 0; i < multipleSelection.length; i++) {
                        let shopDevice = multipleSelection[i];
                        durable = shopDevice.assetType == 1;
                        if (durable) {
                            MsgBox.warning('批量式管理不可修改名称');
                            return;
                        }
                    }
                    let title = multipleSelection[0].title;     // 默认取第一个title
                    //
                    let theDlg = Vue.$showDialog({
                        title: '资产描述全称-批量修改',
                        width: 500,
                        height: 240,
                        showCloseBtn: true,
                        template: '<div class="simple-form">' +
                            '   <div class="form-group center">' +
                            '        <div class="form-label">' +
                            '            <label class="required">资产描述全称</label>' +
                            '        </div>' +
                            '        <div class="form-value width-2x">' +
                            '            <el-input placeholder="请输入名称" v-model="title"></el-input>' +
                            '        </div>' +
                            '   </div>' +
                            '</div>',
                        data: {
                            title: title || null
                        },
                        okClicked: function () {
                            let title = this.title;
                            if (Utils.isNoB(title)) {
                                Toast.show('请输入资产描述全称！');
                                return false;
                            }
                            let postData = {};
                            postData.svcSubNoIds = ids || [];
                            postData.title = title;
                            //
                            let theLoad = MsgBox.loading();
                            devcApi.updateShopDeviceForTitle(postData, function (result) {
                                theLoad.hide();
                                if (result.type === 'info') {
                                    theDlg.close();
                                    //
                                    let resultTable = self.$refs['result_table'];
                                    resultTable.setInitChecked([]);
                                    self.getShopDeviceList();
                                } else {
                                    MsgBox.warning(result.message);
                                }
                            });
                            return false;
                        }
                    });
                } else {
                    MsgBox.warning('未选择数据！');
                }
            },

            // 编辑弹框
            editInfo: function (row) {
                let self = this;
                shopDeviceEditInfoDlg(row, function () {
                    self.pageNumber = 1;
                    self.lastPageNumber = null;
                    self.getShopDeviceList();
                });
            },
            showSvcSubNoInfo: function (row) {
                let showSingleTobObj = {
                    devcBaseInfoFalg: true,
                    repairInfoFalg: true,
                    manageInfoFalg: true,
                    useInfoFalg: true,
                    devcStatisInfoFalg: true,
                    srcInfoFalg: true,
                };
                showShopDeviceInfo(row.id, showSingleTobObj, '资产明细详情 - 查看');
            },
            // 档案记录
            AssetCaseRecord: function (row) {
                let self = this;
                let params = {
                    deviceSubNoId: row.id,
                    durable: false,
                    toServcWork: self.toServcWork
                };
                assetCaseRecordDlg(params);
            },
            // 设备维保情况
            deviceReqMaint: function (row) {
                this.$router.push({
                    query: {
                        tmpNo: row.tmpNo
                    },
                    path: SwbAssetRunRepaire.path
                });
            },
            // 导出贴码
            toExportDevice() {
                let self = this;
                let multipleSelection = this.getTableSelection();
                if (multipleSelection.length == 0) {
                    let postData = self.exportParmas;
                    devcApi.saveDeviceParamsForExport(postData, function (result) {
                        if (result.type == 'info') {
                            self.showTheExportDlg(null, result.data);
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                } else {
                    let postData = [];
                    multipleSelection.forEach(function (el) {
                        postData.push({
                            title: el.title,
                            svcSubNo: el.svcSubNo,
                            tmpNo: el.tmpNo,
                            innerNo: el.innerNo,
                            catName: el.catName,
                            brandName: el.brandName
                        });
                    });
                    //
                    devcApi.saveDeviceModelForExport(postData, function (result) {
                        if (result.type == 'info') {
                            self.showTheExportDlg(result.data);
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                }
            },
            showTheExportDlg(dataUuid = null, paramsUuid = null) {
                let self = this;
                let theDlg = Vue.$showDialog({
                    title: '确定资产贴码文件格式 - 导出' + (dataUuid ? '选中的资产' : ''),
                    showCloseBtn: true,
                    width: 800,
                    height: 600,
                    template: '<div>' +
                        '<div class="hint block" v-if="isShowMessage">' +
                        '   <p>{{message}}</p>' +
                        '</div>' +
                        '<div class="simple-form">' +
                        '   <div class="form-group center">' +
                        '        <div class="form-label">' +
                        '            <label >分组方式</label>' +
                        '        </div>' +
                        '        <div class="form-value width-2x">' +
                        '            <el-radio-group v-model="group">' +
                        '                <el-radio v-for="dataItem in groupTypes" key="value" :label="dataItem[\'value\']">{{dataItem["text"]}}</el-radio>' +
                        '            </el-radio-group>' +
                        '        </div>' +
                        '    </div>' +
                        '   <div class="form-group center">' +
                        '        <div class="form-label">' +
                        '            <label >模版类型</label>' +
                        '        </div>' +
                        '        <div class="form-value width-2x">' +
                        '            <el-radio-group v-model="modelType" @change="modelTypeChange">' +
                        '                <el-radio v-for="dataItem in allModelTypes" key="value" :label="dataItem[\'value\']">{{dataItem["text"]}}</el-radio>' +
                        '            </el-radio-group>' +
                        '        </div>' +
                        '    </div>' +
                        '   <div class="form-group center">' +
                        '        <div class="form-label">' +
                        '            <label >模版尺寸</label>' +
                        '        </div>' +
                        '        <div class="form-value radio width-2x">' +
                        '            <el-radio-group v-model="size">' +
                        '                <el-radio v-for="dataItem in allSizes" key="value" :label="dataItem[\'value\']">{{dataItem["text"]}}</el-radio>' +
                        '            </el-radio-group>' +
                        '        </div>' +
                        '    </div>' +
                        '   <div class="form-group center">' +
                        '        <div class="form-label">' +
                        '            <label >纸张尺寸</label>' +
                        '        </div>' +
                        '        <div class="form-value width-2x">' +
                        '            <el-radio-group v-model="paper">' +
                        '                <el-radio v-for="dataItem in allPaper" key="value" :label="dataItem[\'value\']">{{dataItem["text"]}}</el-radio>' +
                        '            </el-radio-group>' +
                        '        </div>' +
                        '    </div>' +
                        '    <div class="form-group center">' +
                        '        <div class="form-label">' +
                        '            <label >文件格式</label>' +
                        '        </div>' +
                        '        <div class="form-value width-2x">' +
                        '            <el-radio-group v-model="format">' +
                        '                <el-radio v-for="dataItem in allFormats" key="value" :label="dataItem[\'value\']">{{dataItem["text"]}}</el-radio>' +
                        '            </el-radio-group>' +
                        '        </div>' +
                        '    </div>' +
                        '    <div class="form-group center">' +
                        '        <div class="form-label">' +
                        '            <label >打印编码类型</label>' +
                        '        </div>' +
                        '        <div class="form-value width-2x">' +
                        '            <el-radio-group v-model="noType">' +
                        '                <el-radio v-for="dataItem in allNoTypes" key="value" :label="dataItem[\'value\']">{{dataItem["text"]}}</el-radio>' +
                        '            </el-radio-group>' +
                        '        </div>' +
                        '    </div>' +
                        '    <div class="form-group center">' +
                        '        <div class="form-label">' +
                        '            <label >文件名称</label>' +
                        '        </div>' +
                        '        <div class="form-value width-2x">' +
                        '           <el-input v-model="fileName" title="导出文件名称，可选填，默认为 【所属机构名称】-资产服务号（注意：不要带文件扩展名）" clearable ></el-input>' +
                        '        </div>' +
                        '    </div>' +
                        '</div>' +
                        '</div>',
                    data: {
                        groupTypes: [{value: 'cat', text: '分类'}, {value: 'cat brand', text: '分类 + 品牌'}],
                        allModelTypes: [{value: 'standard', text: '标准码'}, {value: 'nonstandard', text: '非标准码'}],
                        allFormats: [{value: 'pdf', text: 'pdf'}, {value: 'docx', text: 'docx'}],
                        allSizes: [],
                        standardSizes: [
                            {value: 'small', text: '小标签(24mm*24mm)'},
                            {value: 'middle', text: '中标签(36mm*36mm)'},
                            {value: 'shoppingCart', text: '购物车标签1(16mm*16mm)'},
                            {value: 'squareLarge', text: '方形大标签(90mm*90mm)'}
                        ],
                        nonstandardSizes: [
                            {value: 'small', text: '小标签(24mm*60mm)'},
                            {value: 'middle', text: '中标签(36mm*80mm)'},
                            {value: 'shoppingCart', text: '购物车标签1(16mm*16mm)'},
                            {value: 'squareSmall', text: '方形小标签(24mm*24mm)'},
                            {value: 'squareLarge', text: '方形大标签(90mm*90mm)'}
                        ],
                        allPaper: [{value: 'A4', text: 'A4'}, {value: '100mm', text: '100mm'}],
                        allNoTypes: [{value: 'tmpNo', text: '系统编号'}, {value: 'innerNo', text: '外部系统编号'}],
                        group: 'cat',
                        format: 'pdf',
                        modelType: 'standard',
                        size: 'small',
                        paper: 'A4',
                        noType: 'tmpNo',
                        fileName: '',
                        message: '注意: 1.请在1分钟内完成导出操作（防止数据过期）；2.以外部系统编号导出时，优先显示外部系统编号',
                        isShowMessage: false
                    },
                    methods: {
                        modelTypeChange() {
                            if (this.modelType == 'standard') {
                                this.allSizes = this.standardSizes;
                            } else {
                                this.allSizes = this.nonstandardSizes;
                            }
                            this.size = this.allSizes[0].value;
                        }
                    },
                    okClicked: function () {
                        let theDownloadUrl = Utils.makeUrl(getAppUrl('/shop/device/stick/qrcode/file/jsp'), {
                            group: this.group,
                            format: this.format,
                            modelType: this.modelType,
                            size: this.size,
                            paper: this.paper,
                            noType: this.noType,
                            fileName: this.fileName,
                            dataUuid: dataUuid || null,
                            paramsUuid: paramsUuid || null
                        });
                        let resultTable = self.$refs['result_table'];
                        resultTable.setInitChecked([]);
                        self.getShopDeviceList();
                        Utils.setPageUrl(theDownloadUrl, '_blank');
                        //
                        return true;
                    },
                    lifecycle: {
                        created: function () {
                            this.isShowMessage = true;
                            this.allSizes = this.standardSizes;
                        }
                    }
                });
            },
            //
            downloadPrintModel() {
                let self = this;
                let theDlg = Vue.$showDialog({
                    title: '下载贴码打印模版',
                    showCloseBtn: true,
                    okText: '下载',
                    width: 600,
                    height: 300,
                    template: '<div class="simple-form">' +
                        '   <div class="form-group center">' +
                        '        <div class="form-label">' +
                        '            <label>型号</label>' +
                        '        </div>' +
                        '        <div class="form-value width-2x">' +
                        '            <el-radio-group v-model="model" @change="modelChange">' +
                        '                <el-radio v-for="dataItem in allModels" key="value" :label="dataItem[\'value\']">{{dataItem["text"]}}</el-radio>' +
                        '            </el-radio-group>' +
                        '        </div>' +
                        '    </div>' +
                        '   <div class="form-group center" v-if="model == \'LW-1000P\'">' +
                        '        <div class="form-label">' +
                        '            <label >尺寸</label>' +
                        '        </div>' +
                        '        <div class="form-value width-2x">' +
                        '            <el-radio-group v-model="size">' +
                        '                <el-radio v-for="dataItem in lwSizes" key="value" :label="dataItem[\'value\']">{{dataItem["text"]}}</el-radio>' +
                        '            </el-radio-group>' +
                        '        </div>' +
                        '    </div>' +
                        '   <div class="form-group center" v-if="model == \'Pro100\'">' +
                        '        <div class="form-label">' +
                        '            <label >尺寸</label>' +
                        '        </div>' +
                        '        <div class="form-value width-2x">' +
                        '            <el-radio-group v-model="size">' +
                        '                <el-radio v-for="dataItem in proSizes" key="value" :label="dataItem[\'value\']">{{dataItem["text"]}}</el-radio>' +
                        '            </el-radio-group>' +
                        '        </div>' +
                        '    </div>' +
                        '</div>',
                    data: {
                        allModels: [{value: 'LW-1000P', text: 'LW-1000P'}, {value: 'Pro100', text: 'Pro100'}],
                        lwSizes: [{value: '24mm', text: '24mm'}, {value: '36mm', text: '36mm'}, {value: 'wwz24mm', text: '24mm*24mm(无文字)'}],
                        proSizes: [{value: '50mm', text: '50mm'}, {value: '100mm', text: '100mm'}],
                        model: 'LW-1000P',
                        size: '24mm'
                    },
                    methods: {
                        modelChange(value) {
                            if (this.model == 'LW-1000P') {
                                this.size = '24mm';
                            } else {
                                this.size = '50mm';
                            }
                        }
                    },
                    okClicked: function () {
                        // 下载模版
                        let url = '/shop/devc/stick/qrcode/tpl/file/for/print/jsp';
                        let postData = {
                            model: this.model,
                            size: this.size
                        };
                        let theDownloadUrl = Utils.makeUrl(getAppUrl(url), postData);
                        Utils.setPageUrl(theDownloadUrl, '_blank');
                        let resultTable = self.$refs['result_table'];
                        resultTable.setInitChecked([]);
                        self.getShopDeviceList();
                        return true;
                    },

                    lifecycle: {
                        created: function () {
                        }
                    }
                });
            },
            exportPrintData1() {
                let self = this;
                //
                let multipleSelection = this.getTableSelection();
                if (multipleSelection.length == 0) {
                    devcApi.saveDeviceParamsForExport(self.exportParmas, function (result) {
                        if (result.type == 'info') {
                            self.showPrintDataDlg(null, result.data);
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                } else {
                    let postData = [];
                    multipleSelection.forEach(function (el) {
                        postData.push({
                            title: el.title,
                            svcSubNo: el.svcSubNo,
                            tmpNo: el.tmpNo,
                            vendorUkno: el.vendorUkno,
                            catName: el.catName,
                            brandName: el.brandName
                        });
                    });
                    //
                    devcApi.saveDeviceModelForExport(postData, function (result) {
                        if (result.type == 'info') {
                            self.showPrintDataDlg(result.data);
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                }
            },
            showPrintDataDlg(dataUuid = null, paramsUuid = null) {
                let self = this;
                let theDlg = Vue.$showDialog({
                    title: '确定资产贴码数据格式 - 导出' + (dataUuid ? '选中的资产' : ''),
                    showCloseBtn: true,
                    width: 600,
                    height: 400,
                    template: '<div class="form-info">' +
                        '   <div class="hint block" v-if="isShowMessage">' +
                        '       <p>{{message}}</p>' +
                        '    </div>' +
                        '<div class="simple-form">' +
                        '    <div class="form-group center">' +
                        '        <div class="form-label">' +
                        '            <label >编码类型</label>' +
                        '        </div>' +
                        '        <div class="form-value width-2x">' +
                        '            <el-radio-group v-model="noType">' +
                        '                <el-radio v-for="dataItem in allNoTypes" key="value" :label="dataItem[\'value\']">{{dataItem["text"]}}</el-radio>' +
                        '            </el-radio-group>' +
                        '        </div>' +
                        '    </div>' +
                        '   <div class="form-group center">' +
                        '        <div class="form-label">' +
                        '            <label>型号</label>' +
                        '        </div>' +
                        '        <div class="form-value width-2x">' +
                        '            <el-radio-group v-model="model" @change="modelChange">' +
                        '                <el-radio v-for="dataItem in allModels" key="value" :label="dataItem[\'value\']">{{dataItem["text"]}}</el-radio>' +
                        '            </el-radio-group>' +
                        '        </div>' +
                        '    </div>' +
                        '   <div class="form-group center" v-if="model == \'LW-1000P\'">' +
                        '        <div class="form-label">' +
                        '            <label >尺寸</label>' +
                        '        </div>' +
                        '        <div class="form-value width-2x">' +
                        '            <el-radio-group v-model="size">' +
                        '                <el-radio v-for="dataItem in lwSizes" key="value" :label="dataItem[\'value\']">{{dataItem["text"]}}</el-radio>' +
                        '            </el-radio-group>' +
                        '        </div>' +
                        '    </div>' +
                        '   <div class="form-group center" v-if="model == \'Pro100\'">' +
                        '        <div class="form-label">' +
                        '            <label >尺寸</label>' +
                        '        </div>' +
                        '        <div class="form-value width-2x">' +
                        '            <el-radio-group v-model="size">' +
                        '                <el-radio v-for="dataItem in proSizes" key="value" :label="dataItem[\'value\']">{{dataItem["text"]}}</el-radio>' +
                        '            </el-radio-group>' +
                        '        </div>' +
                        '    </div>' +
                        '   <div class="form-group center">' +
                        '        <div class="form-label">' +
                        '            <label >分组方式</label>' +
                        '        </div>' +
                        '        <div class="form-value width-2x">' +
                        '            <el-radio-group v-model="group">' +
                        '                <el-radio v-for="dataItem in groupTypes" key="value" :label="dataItem[\'value\']">{{dataItem["text"]}}</el-radio>' +
                        '            </el-radio-group>' +
                        '        </div>' +
                        '    </div>' +
                        '    <div class="form-group center">' +
                        '        <div class="form-label">' +
                        '            <label >文件名称</label>' +
                        '        </div>' +
                        '        <div class="form-value width-2x">' +
                        '           <el-input v-model="fileName" title="导出文件名称，可选填，默认为 【所属机构名称】-资产服务贴码-型号-尺寸（注意：不要带文件扩展名）" clearable style="color:navy;width: 300px;"></el-input>' +
                        '        </div>' +
                        '    </div>' +
                        '</div>' +
                        '</div>',
                    data: {
                        allModels: [{value: 'LW-1000P', text: 'LW-1000P'}, {value: 'Pro100', text: 'Pro100'}],
                        lwSizes: [{value: '24mm', text: '24mm'}, {value: '36mm', text: '36mm'}],
                        proSizes: [{value: '50mm', text: '50mm'}, {value: '100mm', text: '100mm'}],
                        groupTypes: [{value: 'cat', text: '分类'}, {value: 'cat brand', text: '分类 + 品牌'}],
                        allNoTypes: [{value: 'tmpNo', text: '系统编号'}, {value: 'vendorUkno', text: '商品标识码'}],
                        model: 'LW-1000P',
                        noType: 'tmpNo',
                        size: '24mm',
                        group: 'cat',
                        fileName: '',
                        message: '注意: 请在1分钟内完成导出操作（防止数据过期）',
                        isShowMessage: false
                    },
                    methods: {
                        modelChange(value) {
                            if (this.model == 'LW-1000P') {
                                this.size = '24mm';
                            } else {
                                this.size = '50mm';
                            }
                        }
                    },
                    okClicked: function () {
                        // 下载数据
                        let url = '/shop/device/stick/qrcode/data/file/for/print/jsp';
                        let postData = {
                            model: this.model,
                            noType: this.noType,
                            size: this.size,
                            fileName: this.fileName,
                            group: this.group,
                            dataUuid: dataUuid || null,
                            paramsUuid: paramsUuid || null
                        };
                        let theDownloadUrl = Utils.makeUrl(getAppUrl(url), postData);
                        Utils.setPageUrl(theDownloadUrl, '_blank');
                        //
                        let resultTable = self.$refs['result_table'];
                        resultTable.setInitChecked([]);

                        self.getShopDeviceList();
                        return true;
                    },
                    lifecycle: {
                        created: function () {
                            this.isShowMessage = true;
                        }
                    }
                });
            },
            // 导出列表数据
            exportAllAsExcel(type) {
                let title = '资产明细报表';
                let fileName = title + new Date().format('yyyy_MM_dd') + '.xlsx';
                let url = getAppUrl('/file/export/as/excel');
                let tableData = this.getTableData(null, null, type);
                let data = Utils.merge({
                    //指示要一次性单个文件全部导出（最大导出条数 受限于 系统参数 "Xls全量导出最大行数限制"）
                    exportAllAtOnce: true,
                    //指示分批请求数据条目数（每条字段数越大，此值应该越小，【可选】，默认取值（并受限）于系统参数 "Xls全量导出每批量数限制"）
                    exportBatchSize: 1000,
                    //
                    fileName: fileName
                }, tableData);
                let fileInfo = {
                    url: url,
                    post: true,
                    fileName: fileName,
                    data: data
                };
                showDownloadDlg(title, fileInfo);
            },
            shopDeviceSubNoListExport: function () {
                let self = this;
                let pageSize = getDefaultDownloadPageSize();
                let totalCount = this.totalCount;
                let multipleSelection = this.getTableSelection() || [];
                if (multipleSelection.length > 0) {
                    totalCount = multipleSelection.length;
                }
                let pages = Math.ceil(totalCount / pageSize);
                if (pages > 10) {
                    showPageRangeSelDlg('选择导出文件序号', pages, 10, this.lastPageNumber, function (ok, range) {
                        if (ok) {
                            if (range.to == pages) {
                                self.lastPageNumber = 0;
                            } else {
                                self.lastPageNumber = range.to;
                            }
                            //
                            self.exportPrintData(pageSize, range.from, range.to);
                        }
                    }, {pageSize: pageSize})
                } else {
                    self.exportPrintData(pageSize);
                }
            },
            exportPrintData(pageSize, fromPages, toPages) {
                let self = this;
                let totalCount = this.totalCount;
                let multipleSelection = this.getTableSelection();
                if (multipleSelection.length > 0) {
                    totalCount = multipleSelection.length;
                }
                let pages = Math.ceil(totalCount / pageSize);
                //
                fromPages = fromPages == null ? 1 : fromPages;
                toPages = toPages == null ? pages : toPages;
                let tableData = this.getTableData(pages, pageSize);
                //
                let url = getAppUrl('/file/export/as/excel');
                let downloadUrls = [];
                for (let i = fromPages; i <= toPages; i++) {
                    let tmpFile = {};
                    tmpFile.url = url;
                    tmpFile.post = true;
                    tmpFile.fileName = '资产明细报表' + (pages == 1 ? '' : ('_' + (i)));
                    tmpFile.seqNo = i;
                    //
                    let data = Utils.merge({}, tableData);
                    data.pageNumber = i;
                    data.fileName = tmpFile.fileName;
                    tmpFile.data = data;
                    downloadUrls.push(tmpFile);
                }
                let title = '资产明细报表-下载| 每个文件' + pageSize + '条数据';
                showGrpDownloadDlg(title, downloadUrls, function () {
                    let resultTable = self.$refs['result_table'];
                    resultTable.setInitChecked([]);
                    self.getShopDeviceList();
                });
            },
            getTableData(pages, pageSize) {
                let resultTable = this.$refs.result_table;
                let tableData = resultTable.getTableData(true);
                delete tableData.rows;//减少数据传输量
                let cols = tableData.cols || [];
                //
                let devcCustFieldList = this.devcCustFieldList;
                if (devcCustFieldList != null && devcCustFieldList.length > 0) {
                    let exportCols = [];
                    devcCustFieldList.forEach(function (field) {
                        exportCols.push({
                            'name': 'ext-' + field.name,
                            'title': '自定义-' + field.title,
                            'dataType': 'String',
                            'width': 150,
                            'align': 'left',
                            'overflowAsTip': false,
                            'format': null,
                            'asTpl': false
                        });
                    });
                    tableData.cols = cols.concat(exportCols);
                }
                let rowsSrc = {};
                rowsSrc.data = this.getPostData();
                rowsSrc.url = '/shop/device/page/list';
                tableData.rowsSrc = rowsSrc;
                //
                tableData.pageSize = pageSize;
                tableData.pageCount = this.totalCount;
                tableData.pages = pages;
                return tableData;
            },
            getPostData() {
                let queryModel = this.queryModel;
                let filterItems = Utils.merge({}, this.exportParmas);
                let sortItemList = Utils.merge([], queryModel.sortItemList);
                let sortItems = Utils.merge({}, queryModel.sortItems);
                let multipleSelection = this.getTableSelection();
                if (multipleSelection.length > 0) {
                    let ids = [];
                    multipleSelection.forEach(function (el) {
                        ids.push(el.id);
                    });
                    filterItems.ids = ids;
                }
                filterItems.exportFlag = true;
                //
                let postData = {};
                postData.filterItems = filterItems;
                postData.sortItemList = sortItemList;
                postData.sortItems = sortItems;
                //
                return postData;
            },
            popupHandler: function (fieldCode, curValue, curText) {
                let query_model_ctrl = this.$refs['query_model_ctrl'];
                let filter = this.filter || {};
                let thisComId = Utils.isNoB(filter.retailerComId) ? this.scopeEntity.comId : filter.retailerComId;
                if (fieldCode == 'suitIds') {
                    let params = {};
                    params.thisComId = thisComId;
                    params.includeSubComs = filter.includeSubComs;
                    openShopDeviceSuitSelectDlg(params, function (suitList) {
                        let suitIdList = suitList.pluck('id');
                        let suitNameList = suitList.pluck('name');
                        //
                        let suitIds = suitIdList.join('_');
                        let suitNames = suitNameList.join('、');
                        //
                        let fieldInfo = {
                            suitIds: {
                                value: suitIds,
                                text: suitNames
                            }
                        };
                        query_model_ctrl.updateFields(fieldInfo);
                    });
                } else if (fieldCode == 'respblDepartId') {
                    openBizDepartDlg(thisComId, function (bizDepart) {
                        let fieldInfo = {
                            respblDepartId: {
                                value: bizDepart.id,
                                text: bizDepart.name
                            }
                        };
                        query_model_ctrl.updateFields(fieldInfo);
                    });
                } else if (fieldCode == 'applyUseDepartId') {
                    openBizDepartDlg(thisComId, function (bizDepart) {
                        let fieldInfo = {
                            applyUseDepartId: {
                                value: bizDepart.id,
                                text: bizDepart.name
                            }
                        };
                        query_model_ctrl.updateFields(fieldInfo);
                    });
                }
            },
            gotoSuit: function (suitId) {
                let filter = this.filter || {};
                let thisComId = Utils.isNoB(filter.retailerComId) ? this.scopeEntity.comId : filter.retailerComId;
                this.$router.push({
                    query: {
                        suitId: suitId,
                        comId: thisComId,
                        includeSubComs: filter.includeSubComs
                    },
                    path: SwbShopDeviceSuitList.path,
                });
            },
            viewImage: function (fileBrowseUrl) {
                openBigImgDlg(fileBrowseUrl);
            },
            // 设置标签
            setBizTag: function (event) {
                let multipleSelection = this.getTableSelection();
                let ids = multipleSelection.pluck('id');
                if (ids.length <= 0) {
                    MsgBox.warning('请选择资产信息');
                    return;
                }
                //
                this.bizTag = true;
                this.showPopoverRef(event);
            },
            showPopoverRef: function (event) {
                let curBtn = null;
                if (Utils.isNoB(event)) {
                    curBtn = document.getElementById('setTag');
                } else {
                    curBtn = event.currentTarget;
                }
                let popoverRef = this.$refs.popoverRef;
                if (popoverRef != null) {
                    popoverRef.doClear();
                }
                popoverRef = this.$refs.popoverRef;
                popoverRef.bindToReferer(
                    curBtn, 'click', {
                        showNow: true,
                        placement: 'bottom-start'
                    }
                )
            },
            updateBizTag: function (event, row) {
                this.showPopoverRef(event);
                //
                let bizTag = row.bizTag;
                let tagIdList = [];
                if (!Utils.isNoB(bizTag)) {
                    bizTag = bizTag.substring(1, bizTag.length - 1);
                    let idList = bizTag.split('|') || [];
                    for (let i = 0; i < idList.length; i++) {
                        let id = idList[i];
                        tagIdList.push(parseInt(id));
                    }
                }
                this.selectTagIds = Utils.merge([], tagIdList);
                this.selectTagId = row.id;
            },
            doConfirm: function (data) {
                let self = this;
                let popoverRef = self.$refs.popoverRef;
                let tagIds = data.pluck('id') || [];
                //
                if (Utils.isTrue(self.bizTag)) {
                    let multipleSelection = this.getTableSelection();
                    let ids = multipleSelection.pluck('id');
                    if (tagIds.length <= 0) {
                        self.bizTag = false;
                        MsgBox.warning('请选择标签！');
                        return false;
                    }
                    let postData = {
                        ids: ids,
                        tagIds: tagIds,
                    };
                    devcApi.updateShopDeviceBizTagByIds(postData, function (result) {
                        if (result.type == 'info') {
                            MsgBox.success('设置成功');
                            popoverRef.doClear();
                            let resultTable = self.$refs['result_table'];
                            resultTable.setInitChecked([]);
                            self.getShopDeviceList();
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                } else {
                    let postData = {
                        id: self.selectTagId,
                        tagIds: tagIds,
                    };
                    devcApi.updateShopDeviceBizTagById(postData, function (result) {
                        if (result.type == 'info') {
                            MsgBox.success('设置成功');
                            popoverRef.doClear();
                            self.getShopDeviceList();
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                }
                self.bizTag = false;
                self.selectTagId = null;

            },
            doCancel: function () {
                let popoverRef = this.$refs.popoverRef;
                popoverRef.doHide();
                this.bizTag = false;
            },
            // 设置温控信息
            setTemper: function () {
                let self = this;
                let multipleSelection = self.getTableSelection();
                let ids = multipleSelection.pluck('id');
                if (ids.length <= 0) {
                    MsgBox.warning('请选择要设置温控的资产！');
                    return false;
                } else {
                    if (ids.length > 100) {
                        MsgBox.warning('每次最多选择100个资产！');
                        return false;
                    }
                    let durable = false;
                    for (let i = 0; i < multipleSelection.length; i++) {
                        let shopDevice = multipleSelection[i];
                        durable = shopDevice.assetType == 1;
                        if (durable) {
                            MsgBox.warning('批量式管理不可操作');
                            return;
                        }
                    }
                }
                //
                showSetTemperInfoDlg({}, function (temperInfo, theDlg) {
                    let postData = {
                        ids: ids,
                        temperFlag: temperInfo.temperFlag,
                        temperLow: temperInfo.temperLow,
                        temperHigh: temperInfo.temperHigh
                    };
                    let theLoad = MsgBox.loading();
                    devcApi.updateShopDeviceTemperInfoByIds(postData, function (result) {
                        if (result.type == 'info') {
                            theDlg.close();
                            theLoad.hide();
                            if (Utils.isTrue(result.data)) {
                                MsgBox.success('设置成功');
                                let resultTable = self.$refs['result_table'];
                                resultTable.setInitChecked([]);
                                self.getShopDeviceList();
                            } else {
                                MsgBox.warning('设置失败');
                            }
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                });
            },
            // 使用组件
            useAsmblAcc: function (row) {
                let self = this;
                let params = {
                    shopDevcId: row.id
                };
                showAsmblAccStockSetSelectDlg(params, function (resultData, theDlag) {
                    let postData = {
                        id: row.id,
                        shopAsmblAccIoRecList: resultData.asmblRelList,
                        asmblDone: resultData.asmblDone
                    };
                    let theLoad = MsgBox.loading();
                    devcApi.saveShopAsmbleAccIoRecForAssect(postData, function (result) {
                        theLoad.hide();
                        if (result.type == 'info') {
                            theDlag.close();
                            MsgBox.success('操作成功');
                            //
                            self.getShopDeviceList();
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                });
            },
            //
            setAbscent: function (ids, abscent) {
                let self = this;
                let title = abscent ? '确定设置为有实物吗？' : '确定设置为无实物吗？';
                this.$confirm(title, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    let postData = {
                        svcSubNoIds: ids,
                        abscent: !abscent
                    };
                    let theLoad = MsgBox.loading();
                    devcApi.updateShopDeviceAbscent(postData, function (result) {
                        theLoad.hide();
                        if (result.type === 'info') {
                            //
                            self.getShopDeviceList();
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                }).catch(function () {
                });
            },
            // 单品清理
            doShopDeviceClear: function (row) {
                let id = row.id;
                let assetType = row.assetType;
                let clearCause = row.clearCause;
                let self = this;
                let theDlg = Vue.$showDialog({
                    title: '清除',
                    width: 580,
                    height: 400,
                    showCloseBtn: true,
                    template: '<div class="simple-form">' +
                        '<div class="form-group center">' +
                        '<div class="form-label">' +
                        '<label>是否自动审核</label>' +
                        '</div>' +
                        '<div class="form-value width-2x">' +
                        '<el-radio-group v-model="autoAudit">' +
                        '<el-radio :label="true">是</el-radio>' +
                        '<el-radio :label="false">否</el-radio>' +
                        '</el-radio-group>' +
                        '</div>' +
                        '</div>' +
                        '<div class="form-group center">' +
                        '<div class="form-label">' +
                        '<label>清除方式</label>' +
                        '</div>' +
                        '<div class="form-value width-2x">' +
                        '<el-select v-model="clearCause" clearable placeholder="请选择">' +
                        '<el-option v-for="item in devcClearCauseList" :key="item.value" :label="item.text" :value="item.value">' +
                        '</el-option>' +
                        '</el-select>' +
                        '</div>' +
                        '</div>' +
                        '<div class="form-group center">' +
                        '<div class="form-label">' +
                        '<label class="required">清除数量</label>' +
                        '</div>' +
                        '<div class="form-value width-2x">' +
                        '<el-input :disabled="assetTypeFlag" v-model="quantity"></el-input>' +
                        '</div>' +
                        '</div>' +
                        '<div class="form-group center">' +
                        '<div class="form-label">' +
                        '<label>备注</label>' +
                        '</div>' +
                        '<div class="form-value width-2x">' +
                        '<el-input v-model="desc" type="textarea"></el-input>' +
                        '</div>' +
                        '</div>' +
                        '</div>',
                    data: {
                        assetTypeFlag: assetType == 0,
                        devcClearCauseList: getEnumList('devcClearCause'),
                        clearCause: clearCause,
                        autoAudit: true,
                        quantity: 1,
                        desc: null,
                        row: row,
                    },
                    okClicked: function () {
                        let dlgSelf = this;
                        if (!this.assetTypeFlag) {
                            if (Utils.isNoB(this.quantity)) {
                                Toast.show('清除数量不能为空！');
                                return false;
                            } else {
                                if (!Utils.isNaturalStr(this.quantity) || this.quantity <= 0) {
                                    Toast.show('清除数量为大于零的整数！');
                                    return false;
                                } else {
                                    let maxQuantity = row.inStkQuantity;
                                    if (row.fiscalAcctFlag) {
                                        if ((row.fiscalOutQuantity - row.clearedQuantity) < maxQuantity) {
                                            maxQuantity = row.fiscalOutQuantity - row.clearedQuantity;
                                        }
                                        if (parseInt(this.quantity) > maxQuantity) {
                                            Toast.show('清除数量不能大于可清理数量,可清理数量为:' + maxQuantity);
                                            return false;
                                        }
                                    } else {
                                        if (parseInt(this.quantity) > maxQuantity) {
                                            Toast.show('清除数量不能大于可清理数量,可清理数量为:' + maxQuantity);
                                            return false;
                                        }
                                    }
                                }
                            }
                        }
                        self.$confirm('清除资产如果是在用将自动归还！', '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(function () {
                            let postData = {};
                            postData.id = id;
                            postData.clearCause = dlgSelf.clearCause;
                            postData.autoAudit = dlgSelf.autoAudit;
                            postData.desc = dlgSelf.desc;
                            postData.quantity = dlgSelf.quantity;
                            let theLoad = MsgBox.loading();
                            assetVchrApi.doClearedShopDevice(postData, function (result) {
                                theLoad.hide();
                                if (result.type === 'info') {
                                    theDlg.close();
                                    //
                                    MsgBox.success('操作成功');
                                    self.getShopDeviceList();
                                } else {
                                    MsgBox.warning(result.message);
                                }
                            });
                            return false;
                        });
                    },
                    methods: {}
                });
            },
            // 设置布放区
            setLayoutArea: function (row) {
                let self = this;
                let params = {};
                params.bizUnitId = Utils.isNoB(this.retailerBizUnitId) ? this.scopeEntity.bizUnitId : this.retailerBizUnitId;
                params.isRadio = true;
                params.enableSearch = true;
                params.isClickEvent = false;
                // 弹框选择布放区，单选，只能设置二级布放区
                if (Utils.isNoB(row)) {
                    // 判断是否选择设备，批量设备设置布放区
                    let multipleSelection = self.getTableSelection();
                    let ids = multipleSelection.pluck('id');
                    if (ids.length <= 0) {
                        MsgBox.warning('请选择要设置布放区的设备！');
                        return false;
                    } else {
                        if (ids.length > 100) {
                            MsgBox.warning('每次最多选择100个设备！');
                            return false;
                        }
                        let durable = false;
                        for (let i = 0; i < multipleSelection.length; i++) {
                            let shopDevice = multipleSelection[i];
                            durable = shopDevice.assetType == 1;
                            if (durable) {
                                MsgBox.warning('批量式管理不可操作');
                                return;
                            }
                        }
                    }
                    //
                    openLayoutAreaTreeSelectDlg(params, function (layoutArea) {
                        //
                        self.updateLayoutAreaIdByIds(ids, layoutArea.id);
                    });
                } else {
                    // 单个设备设置布放区
                    params.initCheckId = row.layoutAreaId;
                    openLayoutAreaTreeSelectDlg(params, function (layoutArea) {
                        let ids = [];
                        ids.push(row.id);
                        //
                        self.updateLayoutAreaIdByIds(ids, layoutArea.id);
                    });
                }
            },
            cancelLayoutArea: function (row) {
                let self = this;
                self.$confirm('确定要取消布放区域吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    //
                    let ids = [];
                    ids.push(row.id);
                    self.updateLayoutAreaIdByIds(ids, null);
                }).catch(function () {
                });
            },
            updateLayoutAreaIdByIds: function (ids, layoutAreaId) {
                let self = this;
                let postData = {
                    ids: ids,
                    layoutAreaId: layoutAreaId
                };
                let theLoad = MsgBox.loading();
                devcApi.updateShopDeviceLayoutAreaIdByIds(postData, function (result) {
                    theLoad.hide();
                    if (result.type == 'info') {
                        if (Utils.isTrue(result.data)) {
                            MsgBox.success('设置成功');
                            let resultTable = self.$refs['result_table'];
                            resultTable.setInitChecked([]);
                            self.getShopDeviceList();
                        } else {
                            MsgBox.warning('设置失败');
                        }
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 设置归类标签
            setClassifyTag(row) {
                let self = this;
                if (Utils.isNoB(row)) {
                    let multipleSelection = self.getTableSelection();
                    let ids = multipleSelection.pluck('id');
                    if (ids.length <= 0) {
                        MsgBox.warning('请选择要设置归类标签的设备！');
                        return false;
                    } else {
                        let durable = false;
                        for (let i = 0; i < multipleSelection.length; i++) {
                            let shopDevice = multipleSelection[i];
                            durable = shopDevice.assetType == 1;
                            if (durable) {
                                MsgBox.warning('批量式管理不可操作');
                                return;
                            }
                        }
                    }
                    //
                    let devcId = null;
                    if (ids.length == 1) {
                        devcId = ids[0];
                    }
                    showDevcCustInfoSaveDlg(devcId, function (resultData) {
                        resultData.ids = ids;
                        self.saveDevcCustInfo(resultData);
                    });
                } else {
                    showDevcCustInfoSaveDlg(row.id, function (resultData) {
                        resultData.ids = [row.id];
                        self.saveDevcCustInfo(resultData);
                    });
                }
            },
            delClassifyTag(row) {
                let self = this;
                let resultData = {
                    classifyTagId: -1,
                    classifyTagName: ''
                };
                if (Utils.isNoB(row)) {
                    let multipleSelection = self.getTableSelection();
                    let ids = multipleSelection.pluck('id');
                    if (ids.length <= 0) {
                        MsgBox.warning('请选择要设置归类标签的设备！');
                        return false;
                    } else {
                        let durable = false;
                        for (let i = 0; i < multipleSelection.length; i++) {
                            let shopDevice = multipleSelection[i];
                            durable = shopDevice.assetType == 1;
                            if (durable) {
                                MsgBox.warning('批量式管理不可操作');
                                return;
                            }
                        }
                    }
                    resultData.ids = ids;
                } else {
                    resultData.ids = [row.id];
                }
                self.$confirm('确定要移除归类标签吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    self.saveDevcCustInfo(resultData);
                }).catch(function () {
                });
            },
            saveDevcCustInfo(resultData) {
                let self = this;
                let theLoad = MsgBox.loading();
                devcApi.updateDevcCustInfo(resultData, function (result) {
                    theLoad.hide();
                    if (result.type == 'info') {
                        MsgBox.success('操作成功');
                        let resultTable = self.$refs['result_table'];
                        resultTable.setInitChecked([]);
                        self.getShopDeviceList();
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            //
            getDevcCustFieldList() {
                let self = this;
                let theLoading = MsgBox.loading();
                merchtComnApi.getDevcCustFieldList({}, function (result) {
                    theLoading.close();
                    if (result.type == 'info') {
                        self.devcCustFieldList = result.data || [];
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 设备部件
            toViewDevcPart: function (row) {
                showDevcRelatedPartListDlg(row);
            },
            // 维保服务商
            toViewMaintServicer: function (row) {
                let self = this;
                openServicerListForDeviceDlg(row.id, row.devcDefId, row.devcGroupId, null, row.retailerBizUnitId, row, function () {
                    self.getShopDeviceList();
                });
            },
            openShopDeviceImpDevcCheckDlg(fileObj) {
                let self = this;
                // 先调用一次检验方法
                let deviceImpDto = {
                    retailerShopId: self.thisComId,
                    retailerBizUnitId: self.thisBizUnitId,
                    originalFileName: fileObj.extra.originalFileName,
                    deviceImpInfoList: fileObj.extra.deviceImpInfoList,
                    dumyBrandNames: [],
                    tplUsage: 'devc.update.import'
                };
                let theLoading = MsgBox.loading('正在检查导入数据');
                devcApi.validateDeviceFiscalInImpModel(deviceImpDto, function (result) {
                    theLoading.close();
                    let deviceImpDtoServ = result.data;
                    let fileObj2 = {
                        title: '设备更新导入检查',
                        extra: {
                            retailerShopId: deviceImpDtoServ.retailerShopId,
                            retailerBizUnitId: deviceImpDto.retailerBizUnitId,
                            originalFileName: deviceImpDtoServ.originalFileName,
                            deviceImpInfoList: deviceImpDtoServ.deviceImpInfoList,
                            deviceFlag: false,
                            tplUsage: 'devc.update.import'
                        }
                    };
                    openShopDeviceFiscalInImpCheckDlg(fileObj2, function (success) {
                        MsgBox.success('导入成功');
                        // 导入后回调的方法,刷新列表
                        self.getShopDeviceList();
                    });
                });
            },
            generalImport() {
                let self = this;
                let uploadParams = {
                    title: '设备更新导入检查',
                    fileGroup: 'device.import',
                    multipleFile: false,
                    custFileds: JSON.encode(self.devcCustFieldList),
                    usage: 'devc.update.import',
                    lableText: '更新导入',
                    downloadText: '导出数据',
                };
                fileUploadGroupShowDlg(uploadParams, null, function (result, theDlg) {
                    // theDlg 关闭弹框
                    theDlg.close();
                    if (result.type === 'info') {
                        let files = result.data.files;
                        self.file = files[0];
                        // 文件是否按模版导入
                        let errorMsgList = self.file.extra.errorMsgList;
                        if (!Utils.isNoB(errorMsgList) && errorMsgList.length > 0) {
                            MsgBox.warning(errorMsgList.join('<br/>'));
                            return;
                        }
                        self.openShopDeviceImpDevcCheckDlg(self.file);
                    } else {
                        MsgBox.warning(result.message);
                    }
                }, function () {
                    self.exportModel();
                });
            },
            exportModel() {
                let queryModel = this.queryModel;
                let filterItems = Utils.merge({}, this.exportParmas);
                let sortItemList = Utils.merge([], queryModel.sortItemList);
                let sortItems = Utils.merge({}, queryModel.sortItems);
                let multipleSelection = this.getTableSelection();
                if (multipleSelection.length > 0) {
                    if (multipleSelection.length > 20000) {
                        MsgBox.warning('一次最多导出2万条数据');
                        return;
                    }
                    let ids = [];
                    multipleSelection.forEach(function (el) {
                        ids.push(el.id);
                    });
                    filterItems.ids = ids;
                } else {
                    if (this.totalCount > 20000) {
                        MsgBox.warning('一次最多导出2万条数据');
                        return;
                    }
                }
                //
                let postData = {};
                postData.filterItems = filterItems;
                postData.sortItemList = sortItemList;
                postData.sortItems = sortItems;
                //
                devcApi.saveWaitInFiscalDeviceImpParamsForExport(postData, function (result) {
                    Utils.setPageUrl(getAppUrl(result.data + '&usage=devc.update.import'), '_blank');
                });
            },
            taskExport() {
                if (this.totalCount <= 0) {
                    Toast.show('没有需要导出的数据');
                    return;
                }
                let self = this;
                let resultTable = this.$refs.result_table;
                let tableData = resultTable.getTableData(true);
                delete tableData.rows;//减少数据传输量
                tableData.data = this.getPostData(null);
                tableData.pageSize = 1000;
                tableData.fileRows = 500000;
                let asynTaskInfo = {};
                asynTaskInfo.ownerId = this.scopeEntity.id;
                asynTaskInfo.ownerType = this.scopeEntity.scopeId;
                asynTaskInfo.bizCode = 'sbmx.list.export';
                asynTaskInfo.paramInfo = JSON.encode(tableData);
                // 检查唯一键
                let theLoad = MsgBox.loading();
                comnApi.getAsynTaskInfoByUk(asynTaskInfo, function (result) {
                    theLoad.hide();
                    if (result.type == 'info') {
                        let data = result.data;
                        if (data == null) {
                            createTaskExportDlg(asynTaskInfo, function () {
                            });
                        } else {
                            self.$confirm('已经创建了相同参数的任务【' + data.title + '】,确定要重新创建吗?', '提示', {
                                confirmButtonText: '确定',
                                cancelButtonText: '取消',
                                type: 'warning'
                            }).then(function () {
                                createTaskExportDlg(asynTaskInfo, function () {
                                });
                            }).catch(function () {

                            });
                        }
                    } else {
                        self.$message.warning(result.message);
                    }
                });
            },
            viewTaskExport() {
                let params = {};
                params.ownerId = this.scopeEntity.id;
                params.ownerType = this.scopeEntity.scopeId;
                params.bizCode = 'sbmx.list.export';
                viewTaskExportListDlg(params);
            },
            updateAssetIdleX(id, assetIdleX, assetType, fiscalQuantity) {
                let self = this;
                let ids = [];
                if (Utils.isNoB(id)) {
                    let multipleSelection = this.getTableSelection() || [];
                    let length = multipleSelection.length;
                    if (length <= 0) {
                        MsgBox.warning('请选择要操作的设备');
                        return;
                    }
                    for (let i = 0; i < length; i++) {
                        let shopDevice = multipleSelection[i];
                        if (shopDevice.assetIdleX == assetIdleX) {
                            MsgBox.warning('【' + shopDevice.title + '】不可重复设置');
                            return;
                        }
                    }
                    ids = multipleSelection.pluck('id');
                } else {
                    ids = [id];
                }
                if (assetIdleX && assetType != 0) {
                    this.$prompt('确定要资产闲置吗?,请输入闲置数量', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        inputValue: fiscalQuantity
                    }).then(function (data) {
                        let quantity = data.value;
                        if (Utils.isNoB(quantity)) {
                            MsgBox.warning('请输入闲置数量');
                            return false;
                        }
                        if (!Utils.isNumStr(quantity)) {
                            MsgBox.warning('请输入数字');
                            return false;
                        }
                        quantity = parseInt(quantity);
                        if (!Utils.isNumber(quantity) || quantity <= 0) {
                            MsgBox.warning('请输入大于0的数字');
                            return false;
                        }
                        self.updateDevcAssetAspktAssetIdleX(ids, assetIdleX, parseInt(quantity));
                    }).catch(function () {
                    });
                } else {
                    this.$confirm('确定要' + (assetIdleX ? '资产闲置' : '取消闲置') + '吗?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(function () {
                        let quantity = 0;
                        if (assetIdleX && assetType == 0) {
                            quantity = 1;
                        }
                        self.updateDevcAssetAspktAssetIdleX(ids, assetIdleX, quantity);
                    }).catch(function () {
                    });
                }
            },
            //
            updateDevcAssetAspktAssetIdleX(ids, assetIdleX, quantity) {
                let self = this;
                //
                let theLoad = MsgBox.loading();
                let postData = {
                    ids: ids,
                    assetIdleX: assetIdleX,
                    quantity: quantity
                };
                devcApi.updateDevcAssetAspktAssetIdleX(postData, function (result) {
                    theLoad.hide();
                    if (result.type === 'info') {
                        MsgBox.success('设置成功！');
                        //
                        let resultTable = self.$refs['result_table'];
                        resultTable.setInitChecked([]);
                        //
                        self.getShopDeviceList();
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 跳转页面
            toLockedBizVoucher: function (row) {
                let tanKuangFlag = false;
                let deprAdjust = false;
                let bizVoucherText = '';
                let devcVoucherType = null;
                if (Utils.isTrue(row.fiscalLocked)) {
                    devcVoucherType = getEnumInfoWith('devcVoucherType', 'value', row.fiscalLockBizType);
                    if (devcVoucherType.name == 'Allocation' || devcVoucherType.name == 'Scrap' || devcVoucherType.name == 'Clear' || devcVoucherType.name == 'DeprAdjust') {
                        tanKuangFlag = true;
                        if (devcVoucherType.name == 'Allocation') {
                            if (row.fiscalAcctFlag == 1) {
                                bizVoucherText = '调拨';
                            } else {
                                bizVoucherText = '设备调拨';
                            }
                        } else if (devcVoucherType.name == 'DeprAdjust') {
                            bizVoucherText = '价值调整';
                            deprAdjust = true;
                        } else {
                            bizVoucherText = devcVoucherType.text;
                        }
                    }
                } else if (Utils.isTrue(row.locked)) {
                    devcVoucherType = getEnumInfoWith('devcVoucherType', 'value', row.lockBizType);
                    if (devcVoucherType.name == 'Allocation' || devcVoucherType.name == 'Scrap' || devcVoucherType.name == 'Clear' || devcVoucherType.name == 'DeprAdjust') {
                        tanKuangFlag = true;
                        if (devcVoucherType.name == 'Allocation') {
                            if (row.fiscalAcctFlag == 1) {
                                bizVoucherText = '调拨';
                            } else {
                                bizVoucherText = '设备调拨';
                            }
                        } else if (devcVoucherType.name == 'DeprAdjust') {
                            bizVoucherText = '价值调整';
                            deprAdjust = true;
                        } else {
                            bizVoucherText = devcVoucherType.text;
                        }
                    }
                }
                //
                let query = null;
                if (devcVoucherType.name != 'Clear' && devcVoucherType.name != 'Receive' && devcVoucherType.name != 'Appturn') {
                    if (!Utils.isNoB(row.fiscalLockBizInnerNo)) {
                        query = {
                            innerNo: row.fiscalLockBizInnerNo
                        };
                    } else if (!Utils.isNoB(row.fiscalLockBizNo)) {
                        query = {
                            no: row.fiscalLockBizNo
                        };
                    } else if (!Utils.isNoB(row.lockBizInnerNo)) {
                        query = {
                            innerNo: row.lockBizInnerNo
                        };
                    } else if (!Utils.isNoB(row.lockBizNo)) {
                        query = {
                            no: row.lockBizNo
                        };
                    }
                } else {
                    if (!Utils.isNoB(row.fiscalLockBizNo)) {
                        query = {
                            no: row.fiscalLockBizNo
                        };
                    } else if (!Utils.isNoB(row.lockBizNo)) {
                        query = {
                            no: row.lockBizNo
                        };
                    }
                }
                //
                if (tanKuangFlag) {
                    let theDlg = Vue.$showDialog({
                        title: '选择跳转到的页面',
                        showCloseBtn: true,
                        okVisible: false,
                        cancelVisible: false,
                        cancelText: '关闭',
                        width: 200,
                        height: 150,
                        template: '<div><button class="swb-btn swb-btn-small" @click="toApplyPage()" v-if="deprAdjust">{{bizVoucherText}}申请</button>' +
                            '<button class="swb-btn swb-btn-small" @click="toApplyPage()" v-if="!deprAdjust">申请{{bizVoucherText}}</button>' +
                            '<br/>' +
                            '<button class="swb-btn swb-btn-small mt10" @click="toAuditPage()" v-if="deprAdjust">{{bizVoucherText}}审核</button>' +
                            '<button class="swb-btn swb-btn-small mt10" @click="toAuditPage()" v-if="!deprAdjust">审核{{bizVoucherText}}</button></div>',
                        data: {
                            bizVoucherText: null,
                            deprAdjust: false
                        },
                        methods: {
                            // 跳转到申请列表
                            toApplyPage: function () {
                                let hashUrl = null;
                                if (devcVoucherType.name == 'Allocation') {
                                    if (row.fiscalAcctFlag == 1) {
                                        hashUrl = SwbShopDeviceTransVoucherApplyList.path;
                                    } else {
                                        hashUrl = SwbShopDeviceTransVoucherDevcApplyList.path;
                                    }
                                } else if (devcVoucherType.name == 'Scrap') {
                                    hashUrl = SwbShopDeviceScrapVoucherApplyList.path;
                                } else if (devcVoucherType.name == 'Clear') {
                                    hashUrl = SwbShopDeviceClearVoucherApplyList.path;
                                } else {
                                    hashUrl = SwbAssetDeprAdjustVoucherList.path;
                                }
                                //
                                if (query != null) {
                                    hashUrl = Utils.makeUrl(hashUrl, query);
                                }
                                openPageRouteUrl(null, '/bench/home', hashUrl);
                                theDlg.close();
                            },
                            // 跳转到审核列表
                            toAuditPage: function () {
                                let hashUrl = null;
                                if (devcVoucherType.name == 'Allocation') {
                                    if (row.fiscalAcctFlag == 1) {
                                        hashUrl = SwbShopDeviceTransVoucherAuditList.path;
                                    } else {
                                        hashUrl = SwbShopDeviceTransVoucherDevcAuditList.path;
                                    }
                                } else if (devcVoucherType.name == 'Scrap') {
                                    hashUrl = SwbShopDeviceScrapVoucherAuditList.path;
                                } else if (devcVoucherType.name == 'Clear') {
                                    hashUrl = SwbShopDeviceClearVoucherAuditList.path;
                                } else {
                                    hashUrl = SwbAssetDeprAdjustVoucherAuditList.path;
                                }
                                if (query != null) {
                                    hashUrl = Utils.makeUrl(hashUrl, query);
                                }
                                openPageRouteUrl(null, '/bench/home', hashUrl);
                                theDlg.close();
                            }
                        },
                        okClicked: function () {
                        },
                        lifecycle: {
                            created: function () {
                                this.bizVoucherText = bizVoucherText;
                                this.deprAdjust = deprAdjust;
                            }
                        }
                    });
                } else {
                    let hashUrl = null;
                    if (devcVoucherType.name == 'DevcSplit') {
                        // 资产拆分
                        hashUrl = SwbDevcSplitFormList.path;
                    } else if (devcVoucherType.name == 'DevcMerge') {
                        // 资产合并
                        hashUrl = SwbDevcMergeFormList.path;
                    } else if (devcVoucherType.name == 'ManualReceipt') {
                        // 费用验收
                        hashUrl = SwbPurchReceiptManualList.path;
                    } else if (devcVoucherType.name == 'Receive') {
                        // 领用
                        hashUrl = SwbShopDeviceAppturnVoucherList.path;
                    } else if (devcVoucherType.name == 'Appturn') {
                        // 归还
                        hashUrl = SwbShopDeviceAppReturnVoucherList.path;
                    } else {
                        return;
                    }
                    if (query != null) {
                        hashUrl = Utils.makeUrl(hashUrl, query);
                    }
                    openPageRouteUrl(null, '/bench/home', hashUrl);
                }
            }
        }
    }
</script>

<style>
    .form-value.radio .el-radio + .el-radio {
        margin-left: 0;
    }

    .form-value.radio {
        width: calc(100% - 126px - 20px);
        width: -webkit-calc(100% - 126px - 20px);
        width: -moz-calc(100% - 126px - 20px);
    }
</style>



// WEBPACK FOOTER //
// src/compo/devc/ShopDeviceList.vue